import React, { useEffect, useMemo } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import MedicationForm from './MedicationForm';
import MedicationBrand from './MedicationBrand';
import MedicationName from './MedicationName';
import MedicationOften from './MedicationOften';
import MedicationDosage from './MedicationDosage';
import MedicationStrength from './MedicationStrength';
import MedicationConfirm from './MedicationConfirm';
import MedicationSchedule from './MedicationSchedule';
import MedicationHourly from './MedicationHourly';
import MedicationDaily from './MedicationDaily';
import MedicationEveryNDays from './MedicationEveryNDays';
import MedicationWeekly from './MedicationWeekly';
import MedicationWeekDays from './MedicationWeekDays';
//import MedicationSummary from './MedicationSummary';
import chevLeft from 'icons/chevron-left-24.png';
import chevRight from 'icons/chevron-right-24.png';
import xIcon from 'icons/x-icon-24.png';
import { medsCreateState, useMedsCreateState, resetMedsCreateState, createMedsStep } from 'store/storeValtio';
//import { lookupMed } from 'helpers/medicationHelpers';
import MedicationType from './MedicationType';
import SupplementSearch from '../../ingredients/SupplementSearch';
import HelpButton from 'components/help/HelpButton';

export default function AddMedication(props) {
  const navigate = useNavigate();
  // the following is required to force rerender on step changes
  const useMCS = useMedsCreateState();

  const params = useParams();
  const medId = params.id;

  console.log('AddMedication', medsCreateState);

  const NewMedHelp = useMemo(() => {
  var NewMedHelp = [21];
  NewMedHelp[createMedsStep.name] = 'Medname';
  NewMedHelp[createMedsStep.brand] = 'Medbrand';
  NewMedHelp[createMedsStep.type] = 'Medtype';
  NewMedHelp[createMedsStep.form] = 'Medform';
  NewMedHelp[createMedsStep.strength] = 'Medstrength';
  NewMedHelp[createMedsStep.dosage] = 'Meddosage';
  NewMedHelp[createMedsStep.often] = 'Medoften';
  // these are processed as needed
  NewMedHelp[createMedsStep.hourly] = 'Medhourly';
  NewMedHelp[createMedsStep.daily] = 'Meddaily';
  NewMedHelp[createMedsStep.everyndays] = 'Medeveryndays';
  NewMedHelp[createMedsStep.weekly] = 'Medweekly';
  NewMedHelp[createMedsStep.weekdays] = 'Medweekdays';
  NewMedHelp[createMedsStep.schedule] = 'Medschedule';
  NewMedHelp[createMedsStep.search] = 'Medsearch';
  // this is the end game
  NewMedHelp[createMedsStep.confirm] = 'Medconfirm';
  return NewMedHelp;
  },[]);

  useEffect(() => {
    resetMedsCreateState(null);
    //console.log('CreateMed UE', medsCreateState);
  },[])

  function exit(e) {
    e.preventDefault();
    navigate(-1);
  }

  // go back to previous step
  function prevStep() {
    const step = medsCreateState.step;
    //console.log('prevStep', step);
    if (step === createMedsStep.confirm 
      || step === createMedsStep.hourly
      || step === createMedsStep.daily
      || step === createMedsStep.everyndays
      || step === createMedsStep.weekly
      ) {
      // if at confirm or hourly, go back to often
      medsCreateState.step = createMedsStep.often;
      } else if (step === createMedsStep.schedule) {
        console.log('prev schedule', medsCreateState.often);
        if (medsCreateState.often === 'everyndays')
          medsCreateState.step = createMedsStep.everyndays;
        else if (medsCreateState.often === 'weekly')
          medsCreateState.step = createMedsStep.weekdays;
        else if (medsCreateState.often === 'daily')
          medsCreateState.step = createMedsStep.daily;
      } else if (step === createMedsStep.weekdays) {
        medsCreateState.step = createMedsStep.weekly;
      } else if (step > 1 ) 
        medsCreateState.step = step-1;
    };

  // proceed to the next step
  function nextStep(s) {
    let step = medsCreateState.step;
    const max = medsCreateState.maxStep;
    console.log('nextStep', s, medsCreateState);

    if (s && typeof s !== 'object') {
      //console.log('directed nextStep');
      medsCreateState.step = s;
      if (s < 10) medsCreateState.maxStep = s;
    } else {
      // this is only used for the forward arrow as it provides no guidance
      //console.log('nextStep no direction', step);
      const tf = [createMedsStep.schedule, createMedsStep.hourly].includes(step);
      if (tf) {
        //console.log('goto confirm');
        medsCreateState.step = createMedsStep.confirm;
        return;
      }
      if (step === createMedsStep.dosage) {
        medsCreateState.step = createMedsStep.often;
        return;
      }
      if (step === createMedsStep.weekly) {
        medsCreateState.step = createMedsStep.weekdays;
        return;
      }
      if (step === createMedsStep.everyndays) {
        medsCreateState.step = createMedsStep.schedule;
        return;
      }
      if (step === createMedsStep.weekdays) {
        medsCreateState.step = createMedsStep.schedule;
        return;
      }
      if (step < createMedsStep.often && step < max) {
        medsCreateState.step = step + 1;
        return;
      }
    }

    if (step === createMedsStep.often ) {
      const often = medsCreateState.often;
      //console.log('nextStep often', s, step, often);
      // on often, where to go next
      if (often === 'asNeeded' && often === 'other') {
        // often x times per day - get dosage times
        medsCreateState.step = createMedsStep.confirm;
      }
      else if (often === 'hourly') {
        // hourly
        medsCreateState.step = createMedsStep.hourly;
      }
      else if (often === 'daily') {
        // daily
        medsCreateState.step = createMedsStep.daily;
      }
      else if (often === 'everyndays') {
        // everyndays
        medsCreateState.step = createMedsStep.everyndays;
      }
      else if (often === 'weekly') {
        // weekly
        medsCreateState.step = createMedsStep.weekly;
      } else {
        medsCreateState.step = createMedsStep.confirm;
      }

    } 
    else if (step === createMedsStep.daily ) {
      medsCreateState.step = createMedsStep.schedule;
    }
    // else if ( step === createMedsStep.hourly) {
    //     medsCreateState.step = medsCreateState.confirm;
    // } 
    // else {
    //   if (maxStep <= step) medsCreateState.maxStep = step+1;
    //   medsCreateState.step = step + 1;
    // }
  };

  const step = medsCreateState.step;
  const maxStep = medsCreateState.maxStep;
  const name = medsCreateState.name;
  
  //console.log('AddMed render', step, name, NewMedHelp[step] );

  return(
    <>
      <div className='mcard'>
        <div className='mcard-header'>
            <div className='hover:cursor-pointer'>
              {step > 1 && <img src={chevLeft} alt='' onClick={prevStep}/>}
              {step === createMedsStep.name && <img src={xIcon} alt='' onClick={exit}/>}
            </div>
            <div className='font-bold text-xl'>
              { medId && 'Edit '}
              { (!medId && !name) ? 'Enter new medication name' : <>{name}</> }
            </div>
            <HelpButton helpType={NewMedHelp[step]} />
            <div className='hover:cursor-pointer'>
              {(step <= maxStep || true) && <img src={chevRight} alt='' onClick={()=>nextStep(null)} className="hover:cursor-pointer"/>}
            </div>
        </div>
        { step === createMedsStep.name && <MedicationName
              nextStep={nextStep}
            />
        }
        { step === createMedsStep.type && <MedicationType
              nextStep={nextStep}
            />
        }
        { step === createMedsStep.brand && <MedicationBrand
              nextStep={nextStep}
              prevStep={prevStep}
            />
        }
        { step === createMedsStep.form && <MedicationForm
              nextStep={nextStep}
              prevStep={prevStep}
            />
        }
        { step === createMedsStep.strength && <MedicationStrength
              nextStep={nextStep}
              prevStep={prevStep}
            />
        }
        { step === createMedsStep.dosage &&  <MedicationDosage
              nextStep={nextStep}
              prevStep={prevStep}
            />
        }
        { step === createMedsStep.often &&  <MedicationOften
              nextStep={nextStep}
              prevStep={prevStep}
            />
        }
        { step === createMedsStep.schedule &&  <MedicationSchedule
              nextStep={nextStep}
              prevStep={prevStep}
            />
        }
        { step === createMedsStep.hourly &&  <MedicationHourly
              nextStep={nextStep}
              prevStep={prevStep}
            />
        }
        { step === createMedsStep.everyndays &&  <MedicationEveryNDays
              nextStep={nextStep}
              prevStep={prevStep}
            />
        }
        { step === createMedsStep.daily &&  <MedicationDaily
              nextStep={nextStep}
              prevStep={prevStep}
            />
        }
        { step === createMedsStep.weekly &&  <MedicationWeekly
              nextStep={nextStep}
              prevStep={prevStep}
            />
        }
        { step === createMedsStep.weekdays &&  <MedicationWeekDays
              nextStep={nextStep}
              prevStep={prevStep}
            />
        }
        { step === createMedsStep.confirm &&  <MedicationConfirm
              prevStep={prevStep}
            />
        }
        { step === createMedsStep.search &&  <SupplementSearch 
              prevStep={prevStep}
            />
        }
      </div>
    </>  
  );
}
